<template>
	<h-tab-panel>
		<slot></slot>
	</h-tab-panel>
</template>
